import React from 'react';
import { Switch, Route } from 'react-router';

import TransportationSearchScreen from './TransportationSearch';
import TransportationListScreen from './TransportationList';
import TransportationPaymentScreen from './TransportationPayment';
import TransportationSuccessScreen from './TransportationSuccess';
import TransportationDetails from './TransportationDetails';

const baseRoute = '/transportation';

const routes = [
  { path: baseRoute, component: TransportationSearchScreen },
  { path: `${baseRoute}/list`, component: TransportationListScreen },
  { path: `${baseRoute}/payment/:invoiceId`, component: TransportationPaymentScreen },
  {
    path: `${baseRoute}/payment/:invoiceId/payment-success`,
    component: TransportationSuccessScreen,
  },
  {
    path: `${baseRoute}/details`, component: TransportationDetails,
  }
];

export default function TransportationHome() {
  return (
    <Switch>
      {routes.map(route => (
        <Route exact {...route} key={route.path} />
      ))}
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationHome.js